var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}


$('.shopify-payment-button__more-options').css("display", "none");


$('#address_country').change(function(){
    
    var e = document.getElementById("address_country");
    var strselectedCountry = e.options[e.selectedIndex].value;

    if ((strselectedCountry == 'United States') || (strselectedCountry =='Canada')) {
      
      		document.getElementsByName("checkout")[0].style.display = "block";
            
        }
  
    	else {
      		document.getElementsByName("checkout")[0].style.display = "none";
    	}

})




// 	var x = document.getElementById("address_country");
//     var option = document.createElement("option");
//     option.text = "Select Country";
//     x.prepend(option);



//document.getElementById('address_country').selectedIndex = -1;

// var elements = document.getElementById("address_country").options;
// for(var i = 0; i < elements.length; i++){
//       elements[i].selected = false;
//     }